// src/error.ts
var DEFAULT_TECHNICAL_FALLBACK = "Une erreur technique est survenue. Veuillez r\xE9essayer ou contacter le support si le probl\xE8me persiste.";
var DEFAULT_NETWORK_FALLBACK = "Connexion au serveur impossible. V\xE9rifiez votre connexion internet et r\xE9essayez.";
function asError(err) {
  if (!err || typeof err !== "object") {
    return { message: typeof err === "string" ? err : void 0 };
  }
  return err;
}
function getErrorMessage(err, fallback = "Une erreur est survenue") {
  const e = asError(err);
  const messageFromError = (value) => typeof value === "string" ? value : value?.message;
  return e.data?.message || messageFromError(e.data?.error) || e.response?._data?.message || messageFromError(e.response?._data?.error) || e.message || fallback;
}
function extractApiError(e, options) {
  const TECHNICAL_FALLBACK = options?.technicalFallback ?? DEFAULT_TECHNICAL_FALLBACK;
  const NETWORK_FALLBACK = options?.networkFallback ?? DEFAULT_NETWORK_FALLBACK;
  if (!e) {
    return { message: TECHNICAL_FALLBACK, isTechnical: true };
  }
  const err = asError(e);
  const status = err.response?.status ?? err.statusCode ?? err.status;
  const messageFromError = (value) => typeof value === "string" ? value : value?.message;
  const backendMessage = err.data?.message || messageFromError(err.data?.error) || err.response?._data?.message || messageFromError(err.response?._data?.error);
  const isNetworkError = err.name === "FetchError" && !status && !backendMessage;
  if (isNetworkError) {
    return { message: NETWORK_FALLBACK, isTechnical: true };
  }
  if (status && status >= 500) {
    return {
      message: backendMessage || TECHNICAL_FALLBACK,
      isTechnical: true,
      status
    };
  }
  if (backendMessage) {
    return {
      message: backendMessage,
      isTechnical: false,
      status
    };
  }
  if (err.name === "FetchError") {
    return { message: TECHNICAL_FALLBACK, isTechnical: true, status };
  }
  if (typeof err.message === "string" && err.message && !err.message.startsWith("[")) {
    return { message: err.message, isTechnical: false };
  }
  return { message: TECHNICAL_FALLBACK, isTechnical: true };
}
function getInsufficientBalanceInfo(err) {
  const e = asError(err);
  const raw = e.rawResponse;
  const candidates = [
    e.details,
    e.data,
    e.response?._data,
    raw?.error,
    raw
  ];
  const code = e.code ?? e.data?.code ?? candidates.find((c) => c && "code" in c)?.code;
  if (code !== "insufficient_balance") return null;
  const pick = (key) => {
    for (const c of candidates) {
      if (c && c[key] !== void 0 && c[key] !== null) return c[key];
    }
    return void 0;
  };
  const provider = pick("provider");
  const available = pick("available_euros");
  const required = pick("required_euros");
  return {
    provider: provider === "paypal" ? "paypal" : "stripe",
    available_euros: Number(available ?? 0),
    required_euros: Number(required ?? 0),
    organization_id: pick("organization_id") ?? "",
    donate_url: pick("donate_url") ?? null
  };
}
function toError(err) {
  if (err instanceof Error) return err;
  return new Error(getErrorMessage(err));
}

export { asError, extractApiError, getErrorMessage, getInsufficientBalanceInfo, toError };
//# sourceMappingURL=error.js.map
//# sourceMappingURL=error.js.map